var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentEmailIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.01,
    y: 65.76,
    width: 85.11,
    height: 88.72,
    transform: "translate(239.12 220.25) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.77,
    y: 65.76,
    width: 85.11,
    height: 88.72,
    transform: "translate(250.65 220.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,65.74h85.17v88.77H82.74Zm85.12.05H82.8v88.67h85.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.21,
    y: 77.69,
    width: 62.23,
    height: 64.87,
    transform: "translate(250.65 220.25) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.44,143a9.84,9.84,0,0,0,1.54,1.79c1,1.05,2.39,2.46,4,4s3,2.91,4.07,3.89a10.16,10.16,0,0,0,1.8,1.5,10.18,10.18,0,0,0-1.53-1.78c-1-1.05-2.4-2.47-4-4s-3-2.92-4.07-3.9A9.82,9.82,0,0,0,156.44,143Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.21,142.83a9.62,9.62,0,0,0-1.78,1.54c-1.05,1-2.47,2.39-4,3.95s-2.92,3-3.9,4.07a9.28,9.28,0,0,0-1.49,1.8,10.38,10.38,0,0,0,1.77-1.53c1-1,2.48-2.39,4-4s2.93-3,3.9-4.07A9.31,9.31,0,0,0,94.21,142.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.38,77.86a10.63,10.63,0,0,0-1.53-1.78c-1-1-2.39-2.47-4-4s-3-2.92-4.06-3.89a10.45,10.45,0,0,0-1.8-1.5,9.68,9.68,0,0,0,1.52,1.78c1,1.05,2.4,2.47,4,4s3,2.92,4.07,3.89A9.31,9.31,0,0,0,94.38,77.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61,78a10,10,0,0,0,1.79-1.53c1-1,2.46-2.39,4-4s2.91-3,3.89-4.06a10.6,10.6,0,0,0,1.5-1.8A9.17,9.17,0,0,0,166,68.2c-1.05,1-2.47,2.39-4,4s-2.92,3-3.9,4.07A9.82,9.82,0,0,0,156.61,78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.38,142.56a2,2,0,0,0,0-.32c0-.22,0-.51,0-.9,0-.81,0-2,0-3.5,0-3.08,0-7.55.06-13.22,0-11.36.07-27.55.12-46.93l-.24.24,62.05,0h0l-.27-.28c0,23.81,0,46.08,0,64.87l.24-.24-44.93.12-12.63.07-3.33,0-.87,0h0l.83,0,3.3,0,12.57.07,45.08.12h.24v-.24c0-18.79,0-41.06,0-64.87v-.27h-.29l-62.05,0h-.24v.24c0,19.44.09,35.68.12,47.08,0,5.65,0,10.11.07,13.17,0,1.5,0,2.65,0,3.45,0,.38,0,.67,0,.88S94.38,142.56,94.38,142.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.94,
    y: 99.74,
    width: 20.76,
    height: 20.76,
    transform: "translate(250.65 220.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1,
    y: 269.92,
    width: 102.44,
    height: 193.65,
    transform: "translate(208.65 733.49) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.51,
    y: 269.92,
    width: 102.44,
    height: 193.65,
    transform: "translate(269.45 733.49) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,279.08H179v30.7H91.05Zm86.85,1.08H92.13V308.7H177.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68,279.62h23.47a4.95,4.95,0,0,1,4.95,4.95v1.17a0,0,0,0,1,0,0H117.73a0,0,0,0,1,0,0v-1.17A4.95,4.95,0,0,1,122.68,279.62Z",
    transform: "translate(268.83 565.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,318.07H179v30.7H91.05Zm86.85,1.09H92.13v28.53H177.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68,318.62h23.47a4.95,4.95,0,0,1,4.95,4.95v1.17a0,0,0,0,1,0,0H117.73a0,0,0,0,1,0,0v-1.17A4.95,4.95,0,0,1,122.68,318.62Z",
    transform: "translate(268.83 643.35) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,357.07H179v30.69H91.05Zm86.85,1.08H92.13v28.53H177.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68,357.61h23.47a4.95,4.95,0,0,1,4.95,4.95v1.17a0,0,0,0,1,0,0H117.73a0,0,0,0,1,0,0v-1.17A4.95,4.95,0,0,1,122.68,357.61Z",
    transform: "translate(268.83 721.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.05,396.06H179v30.7H91.05Zm86.85,1.08H92.13v28.54H177.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68,396.6h23.47a4.95,4.95,0,0,1,4.95,4.95v1.17a0,0,0,0,1,0,0H117.73a0,0,0,0,1,0,0v-1.17A4.95,4.95,0,0,1,122.68,396.6Z",
    transform: "translate(268.83 799.32) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.22,
    y: 262.67,
    width: 111.27,
    height: 9.65,
    transform: "translate(269.71 534.99) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.76,
    y: 262.67,
    width: 33.46,
    height: 9.65,
    transform: "translate(124.98 534.99) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.56,
    y: 463.57,
    width: 5.38,
    height: 9.89,
    transform: "translate(366.51 937.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.3,
    y: 463.57,
    width: 5.38,
    height: 9.89,
    transform: "translate(299.99 937.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.54,
    y: 463.57,
    width: 5.38,
    height: 9.89,
    transform: "translate(178.47 937.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.16,
    y: 463.57,
    width: 5.38,
    height: 9.89,
    transform: "translate(117.71 937.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.09,
    y: 43.15,
    width: 32.48,
    height: 48.18,
    transform: "translate(195.67 371.82) rotate(-79.01)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,56.31a3.29,3.29,0,0,1-.52.34l-1.54.9-5.72,3.23-19,10.56-.15.09-.12-.14-.28-.33-14.21-16.8L304.37,49q-.72-.87-1.14-1.41a3.31,3.31,0,0,1-.38-.51,3.93,3.93,0,0,1,.44.46l1.21,1.35,4.37,5c3.69,4.31,8.74,10.2,14.31,16.72a4.09,4.09,0,0,1,.28.33l-.27-.05,19-10.45L348,57.4l1.58-.83A4.26,4.26,0,0,1,350.15,56.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,79c-.08-.1,4.33-3.78,9.84-8.22s10-8,10.11-7.88-4.33,3.77-9.84,8.22S296.73,79.1,296.66,79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.41,65.57c.11-.06,2.78,5,6,11.21s5.69,11.36,5.58,11.41-2.78-5-6-11.21S332.3,65.62,332.41,65.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.67,
    y: 96.22,
    width: 37.8,
    height: 25.48,
    transform: "translate(-2.03 209.33) rotate(-26.67)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,89.31a2.45,2.45,0,0,1-.16.46c-.13.33-.31.76-.53,1.3l-2,4.74-6.72,15.65-.06.13-.14,0-.33-.07-16.87-3.62-5.11-1.14-1.38-.32a2.83,2.83,0,0,1-.48-.14,2.57,2.57,0,0,1,.49.07l1.4.26,5.13,1,16.89,3.52.34.07-.2.1c2.66-6.09,5.06-11.59,6.82-15.6L451.17,91l.59-1.27A2.77,2.77,0,0,1,452,89.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.64,129c-.09,0,.88-4.42,2.17-9.82s2.42-9.76,2.51-9.74-.88,4.42-2.17,9.82S429.73,129.06,429.64,129Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,103.56c0-.09,4.11,1.75,9.08,4.1s9,4.33,8.94,4.41-4.11-1.75-9.08-4.1S445.36,103.64,445.4,103.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.81,
    y: 184.94,
    width: 19.45,
    height: 28.86,
    transform: "translate(46.6 455.82) rotate(-78.44)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.66,193l-.31.2-.93.52L314,195.61l-11.42,6.21-.1.05-.07-.08-.16-.2c-3.28-4-6.25-7.53-8.41-10.15l-2.53-3.09-.68-.85a1.43,1.43,0,0,1-.22-.31,2,2,0,0,1,.26.28l.72.82,2.59,3c2.18,2.61,5.17,6.17,8.47,10.1l.17.2-.17,0,11.46-6.14,3.48-1.83.95-.49A1.64,1.64,0,0,1,318.66,193Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.49,206.25c0-.06,2.62-2.23,5.94-4.86s6.06-4.72,6.11-4.66-2.62,2.23-5.94,4.86S286.54,206.31,286.49,206.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,198.41c.06,0,1.63,3,3.5,6.75s3.34,6.84,3.28,6.87-1.64-3-3.51-6.75S307.92,198.45,308,198.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.95 166.35 403.21 161.16 407.79 191.81 360.84 196.42 357.95 166.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,166.36l19.58-19.66a2.48,2.48,0,0,1,3.11-.32l22.57,14.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,196.42c-.06,0,3.14-4.39,7.15-9.71s7.31-9.59,7.37-9.54-3.14,4.39-7.15,9.71S360.9,196.47,360.84,196.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.79,191.82c-.06.05-4-3.45-8.82-7.82s-8.68-8-8.63-8,4,3.45,8.82,7.82S407.84,191.76,407.79,191.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.42 167.79 358.82 153.65 398.44 148.92 400.48 163.76 382.39 181.53 360.42 167.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,167.79l.43.23,1.19.71,4.47,2.73,16,9.89-.27,0,18.06-17.81-.07.22c-.39-2.83-.81-5.8-1.22-8.82-.28-2-.56-4-.83-6l.29.22-39.63,4.64.15-.19c.46,4.42.83,7.94,1.09,10.39q.17,1.78.27,2.79c0,.3,0,.54.06.73a.81.81,0,0,1,0,.25,1.35,1.35,0,0,1,0-.23l-.1-.7q-.13-1-.36-2.76c-.29-2.46-.72-6-1.25-10.43l0-.16.16,0,39.6-4.83.26,0,0,.25q.4,3,.83,6c.42,3,.83,6,1.22,8.82l0,.13-.1.09-18.12,17.75-.12.11-.14-.09-16-10.1-4.39-2.81-1.14-.74A3,3,0,0,1,360.41,167.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,156.72c0,.14-6,.94-13.51,1.79s-13.55,1.43-13.56,1.28,6-.94,13.51-1.79S392.92,156.57,392.93,156.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.36,160.71c0,.15-6,.95-13.51,1.8s-13.55,1.42-13.56,1.28,6-.95,13.51-1.8S393.35,160.57,393.36,160.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.86,165.32c0,.14-6,1-13.51,1.8s-13.55,1.42-13.57,1.28,6-1,13.51-1.8S393.84,165.18,393.86,165.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.35,169.92c0,.15-5.75.92-12.88,1.73s-12.93,1.35-13,1.21,5.75-.92,12.89-1.73S394.34,169.78,394.35,169.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.71,174.51a10,10,0,0,1-2.26.45c-1.41.21-3.36.46-5.51.73s-4.12.47-5.54.59a9.59,9.59,0,0,1-2.31.07,10.61,10.61,0,0,1,2.27-.44c1.41-.21,3.36-.47,5.51-.74s4.12-.46,5.53-.58A10,10,0,0,1,389.71,174.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,179a8.73,8.73,0,0,1-2.86.57,8.44,8.44,0,0,1-2.92,0,8,8,0,0,1,2.86-.57A8.17,8.17,0,0,1,385,179Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.38,404.06a32.05,32.05,0,0,0-10.7-30.32s-2.48-.91-2.27,1.87c.13,1.66-1.47,4-2.79,3-2.31-1.78-1.58-5.39-2.57-8.13-1.17-3.2-4.58-4.91-7.7-6.28-5.76-2.52-11.61-5-17.8-6.09s-12.8-.83-18.44,1.95q2.06,4.13,4.1,8.27a2.9,2.9,0,0,0,3.67,1.84l7.5-.55c1.09-.08,2.49,0,2.81,1.09s-1.06,2.06-2.22,2.47L306.11,376a25.18,25.18,0,0,0,10.4,8.67,75.32,75.32,0,0,0,13,4.43,7.65,7.65,0,0,0,4.3.33c2.29-.74,3.87-3.6,6.26-3.25a10,10,0,0,1-3.69,6.76c9.27,3.64,15.73,8.09,24,11.13",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,445.21a2.46,2.46,0,0,1-.07-.24c0-.19-.09-.42-.16-.71-.13-.66-.32-1.57-.57-2.74-.48-2.41-1.17-5.84-2-10.07-.42-2.13-.88-4.46-1.38-7-.24-1.25-.5-2.55-.76-3.88l-.4-2q-.15-1-.3-2.1c-.87-5.64-1.89-11.94-4.63-17.94s-7.24-10.63-11.49-14.42a96.6,96.6,0,0,0-12.21-9c-3.65-2.34-6.69-4.09-8.78-5.32l-2.41-1.42-.62-.38-.2-.14s.08,0,.23.1l.64.34,2.45,1.34c2.11,1.19,5.18,2.91,8.86,5.21a95.56,95.56,0,0,1,12.32,9,62.12,62.12,0,0,1,6.35,6.41,36.73,36.73,0,0,1,5.26,8.13c2.78,6.08,3.79,12.42,4.64,18.07l.29,2.1.39,2c.25,1.33.5,2.63.74,3.88.47,2.5.91,4.83,1.32,7l1.88,10.09c.21,1.17.38,2.09.49,2.75l.12.72A.94.94,0,0,1,368.33,445.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,341.34c-2,3-7.67,1.53-8-2s4.92-6.09,7.48-3.56a84.58,84.58,0,0,0-3.16-31.16,16.3,16.3,0,0,1-2.93,5.69c-1.45,1.58-3.78,2.57-5.79,1.81-2.72-1-3.52-4.75-2.39-7.43s3.58-4.53,5.92-6.25a29.21,29.21,0,0,0-18.13-14.45c-3,4.88-6.07,9.87-7.43,15.44s-.74,11.94,3,16.31c1.58,1.86,3.67,3.31,4.9,5.42s1.14,5.33-1,6.47c-2.54,1.33-5.41-1.18-6.85-3.67s-2.91-5.53-5.75-6a55.06,55.06,0,0,0,25.45,50.54l-.29-.27A79.21,79.21,0,0,0,382.87,341.34Zm-13-21.92a13.75,13.75,0,0,1,5.28-3,2,2,0,0,1,2.26.6,2.92,2.92,0,0,1,.58,2.36,5.67,5.67,0,0,1-1,2.29,7.56,7.56,0,0,1-3,2.68,4.73,4.73,0,0,1-4,0,2.78,2.78,0,0,1-1.59-2.24A3.75,3.75,0,0,1,369.84,319.42Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,445.21a1.3,1.3,0,0,1,0-.31c0-.23,0-.54,0-.92,0-.83-.08-2-.13-3.52-.13-3.08-.3-7.49-.52-12.93-.48-10.92-1.25-26-2.48-42.64s-2.65-31.67-3.84-42.53c-.58-5.44-1.11-9.83-1.48-12.86-.17-1.5-.31-2.67-.4-3.5,0-.38-.07-.68-.1-.91a1,1,0,0,1,0-.31l.06.3c0,.23.08.53.13.91.12.82.28,2,.49,3.48.42,3,1,7.42,1.62,12.85,1.28,10.86,2.77,25.9,4,42.54s1.94,31.73,2.35,42.66c.2,5.46.31,9.88.37,12.94,0,1.51,0,2.69,0,3.52v.91A2,2,0,0,1,372.07,445.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.05 426.82 348.03 460.67 389.87 460.67 398.71 426.82 340.05 426.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,453.56c0,.64,3.23,20.05,3.23,20.05h25.45l2.8-20.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.71,460.52c0,.12-9.13.22-20.39.22s-20.39-.1-20.39-.22,9.13-.23,20.39-.23S388.71,460.39,388.71,460.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.06,446.87c0,.12-10.76.22-24,.22s-24-.1-24-.22,10.77-.22,24-.22S393.06,446.75,393.06,446.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.18,451.58c0,.13-10.14.23-22.63.23s-22.64-.1-22.64-.23,10.14-.22,22.64-.22S391.18,451.46,391.18,451.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,456.3c0,.12-9.77.22-21.82.22s-21.82-.1-21.82-.22,9.77-.22,21.82-.22S391,456.18,391,456.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.28,442.29c0,.12-11.25.22-25.13.22s-25.12-.1-25.12-.22,11.24-.22,25.12-.22S394.28,442.17,394.28,442.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,438.52c0,.12-11.46.22-25.59.22s-25.6-.1-25.6-.22,11.46-.23,25.6-.23S395.08,438.39,395.08,438.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463,473.64c0,.15-95.38.26-213,.26s-213-.11-213-.26,95.36-.26,213-.26S463,473.5,463,473.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "242.3 430.8 239.59 466.74 223.96 466.42 221.82 429.02 242.3 430.8",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08,462v1s17.56,7.25,17.72,10.59l-35-.5.65-11.64A20,20,0,0,0,240.08,462Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.59,468.57c-.13,0-.33-.73.07-1.55s1.11-1.13,1.17-1-.38.56-.7,1.24S245.74,468.56,245.59,468.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.93,465.27a1.45,1.45,0,0,0-1,1.62,1.39,1.39,0,0,0,1.6,1,1.52,1.52,0,0,0,1.06-1.72,1.42,1.42,0,0,0-1.77-.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,463.15c0,.17-.86.24-1.71.78s-1.31,1.24-1.46,1.17.11-1.05,1.15-1.68S240.23,463,240.19,463.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.84,464.72c0,.17-.7.45-1.29,1.16s-.77,1.48-.94,1.47-.27-1,.48-1.85S243.84,464.56,243.84,464.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,473.16l.15-2.65L256.71,472a2.93,2.93,0,0,1,1.07,1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,118.51s6.55-6.47,8.29-7.56,3.88-3.54,5.23-4.1a39.83,39.83,0,0,0,4.47-2.7l2.66-3.29s2-.21,1.56,2l4.95-1s1.33,1.15-.78,2.51a5,5,0,0,1-3.6,1l-2.08,2.32.36,1.22,12,1.57a2.24,2.24,0,0,1-2.21,2c-2,0-9.24-.31-9.24-.31L357,116.38s.59,1.71-2.9,1.21a80.53,80.53,0,0,1-9.06-2.21l-1,.88,3.05,1.78,2.85,3.68a3.09,3.09,0,0,1-3.61-.81l-1.84-1.8h-2.67s-7.26,5.07-9.69,3.89l-2.06,2.07Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,109.72c.06,0,.27.45.41,1.25a6.74,6.74,0,0,1-.24,3.19,5,5,0,0,1-1.92,2.57c-.67.48-1.16.63-1.19.57s.38-.33,1-.86a5.46,5.46,0,0,0,1.65-2.44C345.91,111.73,345.31,109.74,345.5,109.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.28,118.28a6.45,6.45,0,0,0,3-1.17,8.18,8.18,0,0,0,2.3-2.75,23,23,0,0,0,1.64-4.35l0-.06.06-.06a12.4,12.4,0,0,0,3.3-4.53,10.09,10.09,0,0,0,.7-2.76,1.54,1.54,0,0,0-.34-1.12,1.43,1.43,0,0,0-1-.37l.18-.11a22.57,22.57,0,0,1-5.88,6.11,16,16,0,0,1-2.1,1.25,3.33,3.33,0,0,1-.82.33c0-.07,1.09-.58,2.74-1.83a23.85,23.85,0,0,0,5.65-6.13l.07-.11h.12a1.86,1.86,0,0,1,1.43.51,2,2,0,0,1,.49,1.49,10.14,10.14,0,0,1-.73,2.94,12.7,12.7,0,0,1-3.48,4.72l.09-.12a22.54,22.54,0,0,1-1.75,4.4,8,8,0,0,1-2.49,2.8,5.2,5.2,0,0,1-2.27.91A2.09,2.09,0,0,1,335.28,118.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.54,166.46l47.75-20.23,41.21-29.82,8.34,8.86s-28.88,30.08-36.4,36.22-48.15,32-48.15,32Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,172.57a6.16,6.16,0,0,0-3.66.28c-.38.19-.77.61-.56,1,.13.23.44.29.7.34,4.74.73,9,2.15,13.73,2.89l.8-.34A35.38,35.38,0,0,0,263,172.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,169.68a37.7,37.7,0,0,0,3,6.78l.47-.27a36.6,36.6,0,0,0-.42-7.17,11.4,11.4,0,0,0-2.8-6.19A11,11,0,0,0,271.57,169.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36,167c-1,2.79-1.95,5.47-3,8.26l2-2.05a28.61,28.61,0,0,0,4.4-7.74,2.5,2.5,0,0,0,.17-1,1,1,0,0,0-.56-.83,1.2,1.2,0,0,0-1.09.26A6.35,6.35,0,0,0,279.36,167Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,133.78a5.42,5.42,0,0,0,3.1-1c.29-.24.54-.7.28-1a.81.81,0,0,0-.68-.15c-4.25.38-8.23.06-12.48.44l-.62.46A31.15,31.15,0,0,0,313,133.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.15,138.13a33.21,33.21,0,0,0-4-5.23l-.35.34a32.66,32.66,0,0,0,1.9,6.1,10.07,10.07,0,0,0,3.75,4.75A9.77,9.77,0,0,0,306.15,138.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,142.11c.27-2.62.52-5.14.79-7.76l-1.25,2.18a25.69,25.69,0,0,0-2.14,7.64,2.24,2.24,0,0,0,.07.93.87.87,0,0,0,.67.6,1.06,1.06,0,0,0,.88-.46A5.63,5.63,0,0,0,300,142.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.16 376.3 103.99 388.17 97.99 372.79 133.63 355.58 140.16 376.3",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.81,386.74l-1,.41s0,20.07-3.18,21.57L91,374.36l11.62-4.08A21.17,21.17,0,0,0,108.81,386.74Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,375.22a1.51,1.51,0,0,0-2-.34,1.46,1.46,0,0,0-.35,2,1.6,1.6,0,0,0,2.11.34,1.52,1.52,0,0,0,.14-2.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,374.36l2.8-1,12,33.29s0,1.8-1.2,2.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,387.31c-.17.06-.58-.75-1.45-1.36s-1.74-.77-1.74-.95,1.07-.32,2.11.44S107.91,387.28,107.74,387.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.68,391.51c-.15.1-.72-.51-1.66-.8s-1.75-.16-1.81-.33.85-.65,2-.27S107.84,391.44,107.68,391.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.18,395.27c-.1-.14.65-.71,1.74-.64s1.77.7,1.65.83-.79-.16-1.69-.21S104.26,395.43,104.18,395.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.61,294s-26.52,54-33.64,58.15-89.1,33.33-89.1,33.33L108.56,366l74.19-39.18s9.69-26.42,13.3-46.49c2.21-12.3,7.28-19.51,14.57-29.09,2.23-2.93,6-7.12,7.93-8.41l33.33,6.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.05,250.82l-35.79-6L218,286.9l7.27,88.37s-5,30.72-4.15,50.93c.77,19.06,1.51,26.25,1.51,26.25s15.39.07,18.89.07c1.47,0,14.62-95.65,14.62-95.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66,273.9a4.75,4.75,0,0,1-.24.62c-.19.45-.44,1-.76,1.76l-2.83,6.43c-2.38,5.49-5.63,13-9.21,21.28s-7.22,15.69-10,20.94c-1.39,2.62-2.54,4.73-3.38,6.17l-1,1.65a3.26,3.26,0,0,1-.36.56,3,3,0,0,1,.27-.61c.23-.43.52-1,.88-1.7l3.22-6.24c2.68-5.29,6.21-12.69,9.84-21S238,288,240.49,282.56c1.24-2.7,2.26-4.88,3-6.37l.85-1.71A2.74,2.74,0,0,1,244.66,273.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48,370c.06.13-.4.47-1,.77s-1.17.44-1.24.31.4-.48,1-.78S112.41,369.89,112.48,370Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,365.69c.07.13-.89.72-2.12,1.32a6.16,6.16,0,0,1-2.35.85c-.07-.13.89-.72,2.12-1.32A6.16,6.16,0,0,1,121.43,365.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38,361.33c.07.13-.89.72-2.12,1.33a6.29,6.29,0,0,1-2.35.86c-.07-.13.89-.73,2.12-1.33A6.29,6.29,0,0,1,130.38,361.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.3,357a12.25,12.25,0,0,1-4.46,2.2,11.66,11.66,0,0,1,4.46-2.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,352.52c.07.13-.88.73-2.11,1.35a6.14,6.14,0,0,1-2.34.87c-.07-.13.88-.73,2.11-1.34A6.27,6.27,0,0,1,148.2,352.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,348.05c.07.13-.88.73-2.1,1.35a6.13,6.13,0,0,1-2.34.89,6.29,6.29,0,0,1,2.1-1.35A6.19,6.19,0,0,1,157.09,348.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,343.5a12,12,0,0,1-4.43,2.29,6.16,6.16,0,0,1,2.09-1.38A6.38,6.38,0,0,1,166,343.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.74,338.85c.07.13-.86.75-2.07,1.4a6.05,6.05,0,0,1-2.31.94,6.32,6.32,0,0,1,2.07-1.4A6.05,6.05,0,0,1,174.74,338.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.41,334c.07.12-.83.78-2,1.47a6,6,0,0,1-2.29,1,6.38,6.38,0,0,1,2-1.47A5.9,5.9,0,0,1,183.41,334Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.82,326.56a7,7,0,0,1-.17,2.48,9,9,0,0,0-.1.93,1.56,1.56,0,0,0,0,.2.5.5,0,0,1-.08.31,1.59,1.59,0,0,1-.27.33c-.36.32-.62.42-.67.37s.14-.27.39-.62a1.07,1.07,0,0,0,.16-.27.2.2,0,0,0,0-.08.71.71,0,0,1,0-.23,5.63,5.63,0,0,1,0-1A5.52,5.52,0,0,1,188.82,326.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.13,316.88a6.22,6.22,0,0,1-.35,2.48,6.13,6.13,0,0,1-.86,2.35,6.25,6.25,0,0,1,.35-2.48A6.32,6.32,0,0,1,191.13,316.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,307.27a12.25,12.25,0,0,1-1.29,4.8,6,6,0,0,1,.39-2.47A6.18,6.18,0,0,1,193.68,307.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.35,297.68a11.78,11.78,0,0,1-1.35,4.79,6.12,6.12,0,0,1,.42-2.46A6.22,6.22,0,0,1,196.35,297.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.11,288.12a6.06,6.06,0,0,1-.45,2.46,6.23,6.23,0,0,1-.94,2.32,11.73,11.73,0,0,1,1.39-4.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,278.59a12.07,12.07,0,0,1-1.46,4.76,6.18,6.18,0,0,1,.48-2.46A6.09,6.09,0,0,1,202,278.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.32,269.22a9.64,9.64,0,0,1-.72,2.39,6.07,6.07,0,0,1-1.09,2.24,6.39,6.39,0,0,1,.61-2.44A4.53,4.53,0,0,1,205.32,269.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.68,260.84a6.11,6.11,0,0,1-1.18,2.21c-.77,1.13-1.5,2-1.62,1.91a6.12,6.12,0,0,1,1.19-2.21C209.84,261.62,210.57,260.76,210.68,260.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.54,252.8c.12.09-.45,1-1.27,2.15s-1.57,1.93-1.69,1.85a6.22,6.22,0,0,1,1.27-2.16C215.67,253.54,216.43,252.71,216.54,252.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09,246.85c.11.09-.14.6-.56,1.15s-.85.91-1,.83.14-.6.56-1.15S221,246.76,221.09,246.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32,320.83c-.14,0-.3-.53-.35-1.22s0-1.26.16-1.27.3.54.35,1.23S225.47,320.82,225.32,320.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,331.16a6.81,6.81,0,0,1-.45-2.56,6.39,6.39,0,0,1,.07-2.6,6.81,6.81,0,0,1,.45,2.56A6.6,6.6,0,0,1,226.1,331.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.79,341.5a6.55,6.55,0,0,1-.43-2.57,6.7,6.7,0,0,1,.1-2.6,6.77,6.77,0,0,1,.42,2.57A6.85,6.85,0,0,1,226.79,341.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,351.83a6.49,6.49,0,0,1-.37-2.57,6.35,6.35,0,0,1,.15-2.6,13,13,0,0,1,.22,5.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.53,362.18a6.75,6.75,0,0,1-.3-2.59,6.62,6.62,0,0,1,.22-2.59,13,13,0,0,1,.08,5.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.46,372.53a6.88,6.88,0,0,1-.22-2.6,6.5,6.5,0,0,1,.3-2.58,6.77,6.77,0,0,1,.22,2.59A6.53,6.53,0,0,1,227.46,372.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.05,382.88a6.6,6.6,0,0,1-.13-2.6,6.68,6.68,0,0,1,.38-2.58,6.68,6.68,0,0,1,.14,2.6A6.79,6.79,0,0,1,227.05,382.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.32,393.21a13.25,13.25,0,0,1,.39-5.17,6.41,6.41,0,0,1,.07,2.6A6.78,6.78,0,0,1,226.32,393.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.45,403.52a6.51,6.51,0,0,1,0-2.6,6.62,6.62,0,0,1,.48-2.55,6.74,6.74,0,0,1,0,2.6A6.62,6.62,0,0,1,225.45,403.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,413.85a6.75,6.75,0,0,1-.06-2.6,6.66,6.66,0,0,1,.45-2.57,6.93,6.93,0,0,1,.07,2.61A6.53,6.53,0,0,1,224.63,413.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,424.19a6.91,6.91,0,0,1-.14-2.6,6.77,6.77,0,0,1,.38-2.57,6.61,6.61,0,0,1,.14,2.59A6.46,6.46,0,0,1,224.07,424.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,434.55a6.43,6.43,0,0,1-.27-2.59,6.8,6.8,0,0,1,.24-2.6,6.62,6.62,0,0,1,.28,2.59A7,7,0,0,1,224,434.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.55,444.88a6.64,6.64,0,0,1-.45-2.56,6.36,6.36,0,0,1,.07-2.6,13,13,0,0,1,.38,5.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,452.52c-.14,0-.34-.51-.44-1.2s-.08-1.25.07-1.27.34.52.44,1.2S225.67,452.5,225.53,452.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.45,251a4.08,4.08,0,0,1-.54,1,28.17,28.17,0,0,1-1.78,2.55,23.34,23.34,0,0,1-7.81,6.64,15.43,15.43,0,0,1-10.11,1.33,11,11,0,0,1-2.93-1.1,3.67,3.67,0,0,1-.94-.64,18.59,18.59,0,0,0,3.95,1.38,15.71,15.71,0,0,0,9.8-1.44,24.8,24.8,0,0,0,7.75-6.4C235.51,252.34,236.38,251,236.45,251Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,251.64a12.21,12.21,0,0,1-.44,2.86,41.57,41.57,0,0,1-2.14,6.67,40.81,40.81,0,0,1-3.25,6.21,12.46,12.46,0,0,1-1.73,2.33,21.66,21.66,0,0,1,1.41-2.52,53.73,53.73,0,0,0,5.35-12.78A22.82,22.82,0,0,1,254.31,251.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,252.48c0,.08-.48.12-.81.71a1.26,1.26,0,0,0-.1,1,1.13,1.13,0,0,0,2,0,1.28,1.28,0,0,0-.11-1c-.33-.58-.83-.62-.81-.7s.12-.07.34,0a1.39,1.39,0,0,1,.78.53,1.61,1.61,0,0,1,.26,1.4,1.59,1.59,0,0,1-2.93,0,1.58,1.58,0,0,1,.26-1.4,1.37,1.37,0,0,1,.77-.54C249.91,252.41,250,252.45,250,252.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.48,122.2a13.72,13.72,0,0,0-18.34,6.19c-1.59,3.21-2,7.09-4.37,9.75-2.15,2.37-5.44,3.24-8.47,4.27s-6.25,2.61-7.44,5.59c-1,2.54-.33,5.66-1.88,7.91s-4.77,2.68-7.55,2.86a3,3,0,0,0,2.74,2.28,11.18,11.18,0,0,1-6.72,1.44c.74,3.38,3.72,5.93,7,7s6.82,1.06,10.27.84c3.91-.24,8.09-.79,11-3.4,3.51-3.14,4.62-8.82,8.93-10.74,2.2-1,4.81-.72,7-1.74,3-1.4,4.5-4.9,4.83-8.21s-.21-6.65,0-10,1.53-6.85,4.42-8.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.24,121.22c.29-.64-.45-1.37-1.16-1.34a2.84,2.84,0,0,0-1.77,1.07,12.14,12.14,0,0,0-3.31,6.73,8.36,8.36,0,0,0,2.35,7,2.28,2.28,0,0,0,1.5.76,1.83,1.83,0,0,0,1.47-.92,5,5,0,0,0,.58-1.7,46.61,46.61,0,0,0,.86-11.73Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2,134.61c0-7.15,1.15-14.74,5.76-20.19,4.11-4.85,11.06-8,17.34-9a22.6,22.6,0,0,1,9.83,1.16c4.09,1.32,6.5,5.2,9.06,8.66,5.12,6.92,6.8,17.37,5,20.74L216.7,159.44c-6.27-1.78-13.26-4.52-16-10.42C198.78,145,198.22,139,198.2,134.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.76,120.62l18.9-10.09c6.28-2.28,12.54,4.61,14.55,11,2.24,7.08,4.69,15.82,5.17,21.41,1,11.22-7,14.64-7,14.64h0l3.86,12.68,4.43,14.1-28.69-17-13.69-42.05A3.92,3.92,0,0,1,207.76,120.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.91,128.85a1.42,1.42,0,0,1-1,1.73,1.35,1.35,0,0,1-1.73-.9,1.43,1.43,0,0,1,1-1.73A1.36,1.36,0,0,1,240.91,128.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,125.34c-.1.24-1.39-.13-2.83.41s-2.23,1.65-2.45,1.53,0-.43.28-.94a4,4,0,0,1,1.88-1.44,3.74,3.74,0,0,1,2.34-.1C240,125,240.25,125.24,240.2,125.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.31,132.82a1.43,1.43,0,0,1-1,1.73,1.37,1.37,0,0,1-1.74-.9,1.43,1.43,0,0,1,1-1.73A1.38,1.38,0,0,1,227.31,132.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,129.72c-.12.22-1.37-.29-2.85.08s-2.4,1.39-2.61,1.24,0-.43.39-.89a3.87,3.87,0,0,1,2-1.22,3.72,3.72,0,0,1,2.33.16C225.76,129.33,226,129.62,225.93,129.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,140.19a10.29,10.29,0,0,1,2.31-1c.38-.14.72-.3.72-.58a1.94,1.94,0,0,0-.54-1.06c-.58-.84-1.2-1.71-1.84-2.62-2.58-3.74-4.55-6.86-4.4-7s2.37,2.85,4.95,6.59l1.8,2.64a2.31,2.31,0,0,1,.57,1.45,1,1,0,0,1-.49.71,2.68,2.68,0,0,1-.62.25A10,10,0,0,1,234,140.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,157.57A28.32,28.32,0,0,1,224,157.3s5.66,6.59,16.22,2.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.77,144.19a2.46,2.46,0,0,1,1.72-1.58,3.22,3.22,0,0,1,3.18.71,2,2,0,0,1,.48,1.36c-.05.27,0,.13-.14.34a5.55,5.55,0,0,1-1.89,1.93,2.4,2.4,0,0,1-2.69-.3A2.44,2.44,0,0,1,229.77,144.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,142.31c.24-.08.64,1.54,2.31,2.35s3.35.2,3.42.42-.31.41-1,.61a4.17,4.17,0,0,1-2.83-.26,3.63,3.63,0,0,1-1.83-2C229.68,142.77,229.76,142.33,229.87,142.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48,126c0,.45-1.58.62-3.28,1.27s-3,1.47-3.31,1.16c-.15-.15,0-.59.48-1.12a5.8,5.8,0,0,1,2.29-1.51,5.94,5.94,0,0,1,2.73-.34C225.09,125.59,225.5,125.83,225.48,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.62,121.56c-.18.4-1.29.3-2.53.59s-2.22.79-2.55.5c-.15-.15-.07-.53.31-1a3.57,3.57,0,0,1,1.91-1.06,3.53,3.53,0,0,1,2.18.18C238.47,121.05,238.7,121.36,238.62,121.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,137.78c-.17,0-6.49-.49-5,5.54s7.24,3.27,7.21,3.1S211.39,137.78,211.39,137.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,144.59s-.09.1-.25.23a1.07,1.07,0,0,1-.78.21c-.69-.07-1.48-.95-1.78-2a3.57,3.57,0,0,1-.08-1.58,1.24,1.24,0,0,1,.59-1,.56.56,0,0,1,.69.13c.12.15.11.28.15.28s.1-.13,0-.37a.71.71,0,0,0-.33-.31.78.78,0,0,0-.62,0,1.5,1.5,0,0,0-.86,1.21,3.69,3.69,0,0,0,0,1.77,2.83,2.83,0,0,0,2.18,2.22,1.19,1.19,0,0,0,.92-.4C211.23,144.74,211.23,144.6,211.21,144.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,147.08s-.2.32,0,.85a1.16,1.16,0,0,0,.63.75,1.3,1.3,0,0,0,1.18-.2,1.24,1.24,0,0,0,.6-1,1.3,1.3,0,0,0-.39-.89c-.41-.39-.8-.34-.79-.31s.32.09.63.46a1.18,1.18,0,0,1,.26.74,1,1,0,0,1-.49.77,1.06,1.06,0,0,1-.9.19,1,1,0,0,1-.52-.56A3.54,3.54,0,0,1,209.69,147.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,121.63a9.76,9.76,0,0,0-5-3c-1.9-.55-3.89-.81-5.79-1.38a18.62,18.62,0,0,1-10.55-8.2,11.2,11.2,0,0,1,9.7-2.19,15.13,15.13,0,0,1,8.41,5.61,23.76,23.76,0,0,1,4.2,9.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,118.82c3.44-5.31,11.31-9.68,17.61-9.09.36,5.29-2.1,11.92-4.54,16.63s-2.85,12.1-10.8,11.54c-.55,0-1,.57-1.55.41a2,2,0,0,1-1-.95A17.81,17.81,0,0,1,206.05,118.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,110.13a6.33,6.33,0,0,1-.08,1.39c-.1.89-.24,2.17-.46,3.76a68,68,0,0,1-2.69,12.23,37,37,0,0,1-2.79,6.33,9.58,9.58,0,0,1-3.73,4.24,4,4,0,0,1-3.78,0,2.56,2.56,0,0,1-.79-.69c-.14-.2-.19-.32-.17-.33a3.55,3.55,0,0,0,4.57.72,9.52,9.52,0,0,0,3.48-4.15,39.53,39.53,0,0,0,2.72-6.27,80.53,80.53,0,0,0,2.82-12.12c.24-1.5.45-2.75.62-3.73A8,8,0,0,1,223.54,110.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.56,153.3a2.19,2.19,0,0,1-.14-.62,5.68,5.68,0,0,1,.1-1.81,6.82,6.82,0,0,1,1.21-2.62,6.65,6.65,0,0,1,3.05-2.29,8.15,8.15,0,0,1,4.62,0,8.3,8.3,0,0,0,5,0,8.2,8.2,0,0,0,4-3.83,17.36,17.36,0,0,0,1.77-5.85,46.46,46.46,0,0,1,1.2-6.15,14.59,14.59,0,0,1,2.78-5.16,14.43,14.43,0,0,1,15.06-4.67,13.38,13.38,0,0,1,1.7.62,3.11,3.11,0,0,1,.56.3c0,.05-.8-.35-2.32-.72a14.63,14.63,0,0,0-6.5-.14,14.14,14.14,0,0,0-8.13,4.92,14.3,14.3,0,0,0-2.67,5,48,48,0,0,0-1.16,6.09,17.75,17.75,0,0,1-1.84,6,8.65,8.65,0,0,1-4.25,4,6.3,6.3,0,0,1-2.76.39,17.69,17.69,0,0,1-2.54-.43,7.73,7.73,0,0,0-4.41-.08,6.39,6.39,0,0,0-2.94,2.12,6.84,6.84,0,0,0-1.24,2.48A7.14,7.14,0,0,0,157.56,153.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.77,119.82a3.8,3.8,0,0,1,.46-.92,10.75,10.75,0,0,1,1.79-2.19,16.85,16.85,0,0,1,8.26-4.16,32.68,32.68,0,0,1,9.27-.35c1.18.11,2.13.22,2.79.32a3.58,3.58,0,0,1,1,.2,35.78,35.78,0,0,1-3.83-.15,37.18,37.18,0,0,0-9.14.49,17.52,17.52,0,0,0-8.11,3.92A22.31,22.31,0,0,0,199.77,119.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.08,110.45a8.3,8.3,0,0,1,2.36-.86,24.58,24.58,0,0,1,6-.79,18.66,18.66,0,0,1,3.34.25,4.25,4.25,0,0,1,2.46,1.3,2.68,2.68,0,0,1,.71,1.74c0,.45-.14.68-.16.67s0-.25,0-.66a2.72,2.72,0,0,0-.78-1.5,4,4,0,0,0-2.28-1.08,19.54,19.54,0,0,0-3.25-.19,30.34,30.34,0,0,0-5.91.62A24.33,24.33,0,0,1,208.08,110.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,144a1.2,1.2,0,0,1-.17-.41,5,5,0,0,1-.28-1.22,8.19,8.19,0,0,1,.86-4.52,13.27,13.27,0,0,1,4.5-5.12,77.1,77.1,0,0,1,7.25-4.12,29.93,29.93,0,0,0,10.81-10.15,29.6,29.6,0,0,0,2.16-4,11.88,11.88,0,0,1,.71-1.52,1.68,1.68,0,0,1-.11.42c-.09.27-.2.68-.41,1.18a26.6,26.6,0,0,1-2,4.13,29.19,29.19,0,0,1-10.88,10.41,81.34,81.34,0,0,0-7.22,4,13.24,13.24,0,0,0-4.45,4.89,8.41,8.41,0,0,0-1,4.34C197.12,143.45,197.35,144,197.29,144Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,184.35c-.08,0-.07-1-.35-2.64a18.3,18.3,0,0,0-2.14-6,10.11,10.11,0,0,0-4.36-4.44,6.29,6.29,0,0,0-2.56-.41,1.54,1.54,0,0,1,.71-.19,4.27,4.27,0,0,1,2,.28,9.67,9.67,0,0,1,4.66,4.51,16.46,16.46,0,0,1,2.06,6.17A7.65,7.65,0,0,1,221,184.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.48,166.9,248.15,185l-6.79-21,5.74,2.94s10.24,18.94,13.5,28.47a67.46,67.46,0,0,1,2.82,11.37c.76,6.85-3.06,14.51-3.06,14.51L263.63,246c.46,2.66-1.27,5.23-2.44,5.23l-37.07-5c-4.83-.95-6.81-3.48-6.52-6.28l.56-5.18-15.84-53c-.93,3.14-1.9-7.62,5.17-10.21C210.48,170.43,219.93,166,224.48,166.9Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,177.21s.12.12.3.38l.77,1.13c.66,1,1.6,2.42,2.71,4.23a67.18,67.18,0,0,1,7.2,14.93,33,33,0,0,1,1.11,16.47,22.13,22.13,0,0,1-1.55,4.8c-.23.55-.48.94-.62,1.22a1.89,1.89,0,0,1-.25.4s.25-.61.69-1.7a25.38,25.38,0,0,0,1.39-4.79A34.09,34.09,0,0,0,261.51,198a73.09,73.09,0,0,0-7-14.9l-2.57-4.31-.7-1.18A2,2,0,0,1,251,177.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.75,242.38a6.38,6.38,0,0,0-1,3.58c.05.43.32,1,.75.89.27,0,.44-.31.57-.55,2.37-4.26,4.61-7.89,7-12.15l-.11-.84A33.39,33.39,0,0,0,254.75,242.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,232.23a38,38,0,0,0,7.6-.32l-.06-.43a39.69,39.69,0,0,0-7.1-2.36,11.54,11.54,0,0,0-6.88.5A11.18,11.18,0,0,0,254.13,232.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.32,223.86l7.13,6L259.88,227a29.2,29.2,0,0,0-5.84-6.91,2.47,2.47,0,0,0-.93-.53,1,1,0,0,0-1,.24,1.23,1.23,0,0,0-.13,1.14A6.46,6.46,0,0,0,254.32,223.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.43,216.44c2,1.31,4,1.73,6.15,2.59H240a34.52,34.52,0,0,0-4.75-5.13,11.55,11.55,0,0,0-6.32-2.78A11.06,11.06,0,0,0,233.43,216.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.68,210.46c1.13,2.79,2.23,5.45,3.36,8.25l.09-2.88A29.57,29.57,0,0,0,240.2,207a2.81,2.81,0,0,0-.57-.9,1,1,0,0,0-1-.24,1.2,1.2,0,0,0-.64.93A6.47,6.47,0,0,0,238.68,210.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,207.73a2.77,2.77,0,0,1-.2.8,5.62,5.62,0,0,1-.33.89,12.29,12.29,0,0,1-.53,1.15,17,17,0,0,1-1.83,2.76,17.54,17.54,0,0,1-6.39,4.88,16.54,16.54,0,0,1-3.14,1,11.81,11.81,0,0,1-2.2.3,2.7,2.7,0,0,1-.81,0c0-.1,1.15-.15,2.93-.62a18.15,18.15,0,0,0,3-1.11,20.74,20.74,0,0,0,3.37-2,20.22,20.22,0,0,0,2.86-2.72,18.67,18.67,0,0,0,1.87-2.63C252.25,208.8,252.61,207.7,252.7,207.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235,219.88a9.89,9.89,0,0,0,11.17.18c3.56-2.23,5.29-6.08,5.75-10A20.19,20.19,0,0,1,235,219.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.06,196.24l-4.5,6.4c.94,3.55,2.18,6.89,3.12,10.43A30.24,30.24,0,0,0,213.06,196.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M147.93,271.44l-6.47,10.28L127.13,286a3.58,3.58,0,0,1,.82-2.68c1-.92-3,.38-3,.38l-3,6.24s-2-.14-1.89-1.89,2.38-7.25,2.38-7.25l1.07-.18a3.19,3.19,0,0,1,.41-2.88,9.86,9.86,0,0,1,1.62-4.82,15.27,15.27,0,0,1,2.94-3.48L141,264.28Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,279.4a18.7,18.7,0,0,1-4.66,2.3,18.49,18.49,0,0,1-5,1.37c0-.13,2.19-.79,4.85-1.8S137.84,279.28,137.9,279.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,278.12a17.72,17.72,0,0,1-3.67,1.63,17.42,17.42,0,0,1-3.82,1.2,17.17,17.17,0,0,1,3.66-1.63A17.58,17.58,0,0,1,130,278.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.76,275a27.14,27.14,0,0,1-2.94,1.36,27.31,27.31,0,0,1-2.9,1.45,10.46,10.46,0,0,1,5.84-2.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82,271.86a11,11,0,0,1-2.33,1.12,11.63,11.63,0,0,1-2.39,1,5.59,5.59,0,0,1,2.2-1.41A5.53,5.53,0,0,1,129.82,271.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.83,172.51a8.12,8.12,0,0,1,1.76,1.92,17.75,17.75,0,0,1,2.71,5.69,17.54,17.54,0,0,1,.53,6.27,8,8,0,0,1-.55,2.55c-.09,0,.11-1,.18-2.58a19.9,19.9,0,0,0-3.17-11.72C215.42,173.31,214.76,172.57,214.83,172.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,171.2c3.3,0,6.34,3.05,6.62,6.34.34,3.9.38,9.68-1.55,14.21-3.23,7.56-36,46.43-36,46.43l-31.59,33.26-8.14-8.15s16.79-27.44,19.07-30.75c4.74-6.91,16.67-19.08,21.4-27.16s15.3-22.9,18.49-26.13S204.63,171.21,210.46,171.2Z",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,209.07a6.42,6.42,0,0,0-3.57,1.33c-.32.3-.59.84-.27,1.15a.91.91,0,0,0,.79.14c4.95-.64,9.53-1,14.48-1.65l.38-.58A34.21,34.21,0,0,0,190.92,209.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.91,202.39a35.8,35.8,0,0,0,4.65,5.78l.27-.46a34.57,34.57,0,0,0-2.1-6.85,11.71,11.71,0,0,0-4.59-5.36A11.41,11.41,0,0,0,198.91,202.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.92,197.08c-.2,3.07-.37,6-.57,9.09l1.35-2.6a29.79,29.79,0,0,0,2.15-9,2.68,2.68,0,0,0-.12-1.09,1,1,0,0,0-.81-.66,1.24,1.24,0,0,0-1,.58A6.58,6.58,0,0,0,205.92,197.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,195.6a1.69,1.69,0,0,1-.23.43c-.2.31-.44.7-.74,1.16-.66,1-1.65,2.43-2.9,4.16-2.52,3.47-6.12,8.17-10.18,13.29s-7.83,9.68-10.6,13c-1.38,1.63-2.52,2.94-3.31,3.84l-.93,1c-.22.23-.34.35-.35.33s.08-.14.27-.4l.86-1.08,3.18-3.94,10.48-13c4.06-5.11,7.7-9.77,10.29-13.18,1.24-1.67,2.26-3,3-4.06.32-.44.59-.81.82-1.11A2,2,0,0,1,213,195.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.07,229.56a34.18,34.18,0,0,0,11.73,1.38,6.39,6.39,0,0,0,3.67-1c.35-.27.66-.78.37-1.12a.92.92,0,0,0-.78-.2c-5,.21-9.58.21-14.56.42",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,236.92a35.8,35.8,0,0,0-4.14-6.15l-.32.44a35.28,35.28,0,0,0,1.52,7,11.72,11.72,0,0,0,4.12,5.74A11.45,11.45,0,0,0,164.28,236.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,242.53c.46-3.05.88-6,1.34-9L156.64,236a30.16,30.16,0,0,0-2.91,8.8,2.67,2.67,0,0,0,0,1.09,1,1,0,0,0,.74.73,1.24,1.24,0,0,0,1.06-.49A6.53,6.53,0,0,0,156.87,242.53Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "398.5 62.82 403.13 68.8 404.73 78.64 408.23 76.18 411.73 81.39 442.75 52.01 398.5 62.82",
    style: {
      fill: "#EFDDCC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.18 76.24 406.6 77.32 405.48 71.81 408.18 76.24",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.13 68.8 442.75 52.01 405.72 71.25 404.73 78.64 403.13 68.8",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.75,52a2.36,2.36,0,0,1-.46.3l-1.36.77-5.07,2.74L419,64.68l-13.49,7,.09-.29c1.7,3.09,3.24,5.57,4.34,7.28.53.82.95,1.48,1.29,2a3.53,3.53,0,0,1,.42.72,4.07,4.07,0,0,1-.53-.65c-.33-.43-.8-1.08-1.38-1.92-1.17-1.68-2.77-4.13-4.52-7.21l-.11-.19.2-.11,13.45-7.07,16.88-8.73,5.15-2.59,1.41-.69A1.84,1.84,0,0,1,442.75,52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.75,52c.06.13-8.82,4-19.83,8.73s-20,8.38-20,8.25,8.82-4,19.83-8.73S442.7,51.88,442.75,52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,78.64a12.75,12.75,0,0,1,.1-3.61,12.89,12.89,0,0,1,.62-3.55,12.69,12.69,0,0,1-.1,3.6A12.49,12.49,0,0,1,404.73,78.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.7,103c0,.14-.51.33-1.21.43s-1.26,0-1.27-.09.53-.34,1.2-.43S366.67,102.84,366.7,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.61,99c.08.11-.74.88-1.92,1.58a4.92,4.92,0,0,1-2.32.91c-.06-.14.9-.68,2.05-1.36A7.77,7.77,0,0,1,375.61,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.06,91.66a4.91,4.91,0,0,1-1.1,2.23c-.79,1.13-1.63,1.87-1.74,1.78a8.25,8.25,0,0,1,1.32-2.08C381.31,92.5,381.93,91.59,382.06,91.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.41,82.24a4.26,4.26,0,0,1,.22,2.48,4.48,4.48,0,0,1-.72,2.39,9.16,9.16,0,0,1,.2-2.44A10.52,10.52,0,0,1,384.41,82.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.46,75.48a3.37,3.37,0,0,1,2.47.45c1.3.65,1.88,1.72,1.78,1.77s-.85-.73-2-1.31S378.44,75.64,378.46,75.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,80.25a3.53,3.53,0,0,1,1-2.3,3.37,3.37,0,0,1,2.06-1.43c.08.13-.83.74-1.65,1.76S370.8,80.3,370.66,80.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,89.51a3.89,3.89,0,0,1-1.54-2,3.84,3.84,0,0,1-.48-2.45,14.84,14.84,0,0,1,1,2.24C371.75,88.53,372.4,89.4,372.27,89.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.83,93.83a4.31,4.31,0,0,1-2.48-.19,4.26,4.26,0,0,1-2.23-1.12,10.85,10.85,0,0,1,2.37.62A10.05,10.05,0,0,1,380.83,93.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.34,91.83A4.82,4.82,0,0,1,388.17,93a4.67,4.67,0,0,1-2.45.44,8.77,8.77,0,0,1,2.27-.93A8.37,8.37,0,0,1,390.34,91.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.32,86.14c.1.1-.68.89-1.74,1.75a6,6,0,0,1-2.06,1.36c-.09-.12.69-.91,1.74-1.76A6.08,6.08,0,0,1,398.32,86.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.2,80.58c.13.06,0,.63-.45,1.21s-.86.93-1,.84.16-.59.55-1.14S403.07,80.52,403.2,80.58Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentEmailIllustration);
export default __webpack_public_path__ + "static/media/sent-email-illustration.6780cb8393255befc5d57267ca1b4e43.svg";
export { ForwardRef as ReactComponent };